var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHongKong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#db362f",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.3 5.58a3.41 3.41 0 0 0-1.79 6.53c-.16-.14-.23-.35-.31-.55a1.46 1.46 0 0 1 .78-1.9 1.7 1.7 0 0 0 1-1.22 1.7 1.7 0 0 0-.24-1.29 1.05 1.05 0 0 1 .56-1.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.32 8.82a3.4 3.4 0 0 0-3.63 3.17c.09-.2.26-.32.42-.46a1.46 1.46 0 0 1 2.06.14q.1.12.22.21c.73.6 1.8.48 2.4-.25a1.06 1.06 0 0 1 1.67.05 3.4 3.4 0 0 0-3.14-2.86m-3.54 3.5c.05.21-.02.42-.06.63a1.46 1.46 0 0 1-1.76 1.1 1.7 1.7 0 0 0-2.08 1.56 1.05 1.05 0 0 1-1.39.95 3.41 3.41 0 0 0 5.3-4.23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 14.6a3.4 3.4 0 0 0-4.14-2.47c.2.02.39.14.57.25.7.42.91 1.31.5 2a1.7 1.7 0 0 0 .85 2.48q.13.04.24.13c.47.34.57 1 .23 1.47A3.4 3.4 0 0 0 19 14.6m-5.05-2.15a1.46 1.46 0 0 1-1.57-1.33 1.7 1.7 0 0 0-2.14-1.5A1.05 1.05 0 0 1 8.9 8.59a3.4 3.4 0 0 0 5.66 3.73c-.18.1-.4.1-.62.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKong);
export default __webpack_public_path__ + "static/media/hong-kong.362d3f17b34673de166502c54275af62.svg";
export { ForwardRef as ReactComponent };